import { ListsState } from './types'

export const initialListsState: ListsState = {
  createModalOpen: false,
  importModeModalOpen: false,
  importMode: null,
  importerOpen: false,
  importerListId: null,
  activeImportFileUploadId: null,
}
